import { icons } from '@ublend-npm/aulaui-next';
import React from 'react';
import { Transforms } from 'slate';
import { ReactEditor } from 'slate-react';
import { NestedMenuItem } from '../../components/NestedMenu/NestedMenu';
import { AulaPlugin } from '../plugins';

/**
 * plainTextMenuItem plugin
 *
 * A plugin that adds the `Text` menu item to the plus menu
 */
export const plainTextMenuItem: AulaPlugin = (editableProps, editor) => ({
  ...editableProps,
  blockMenu: {
    ...editableProps.blockMenu,
    Text: ({ text, element, attributes, onClose }) => (
      <NestedMenuItem
        leftIcon={<icons.TitleIcon />}
        key={text}
        text={text}
        attributes={{
          ...attributes,
          onClick: () => {
            const path = ReactEditor.findPath(editor, element);
            onClose?.();
            Transforms.insertNodes(
              editor,
              [
                {
                  children: [
                    {
                      text: '',
                    },
                  ],
                },
              ],
              {
                at: [path[0] + 1],
              },
            );

            setTimeout(() => {
              Transforms.select(editor, [path[0] + 1]);
            }, 0);
          },
        }}
      />
    ),
  },
});
